// 单产品算费模块  mixin
import { mapState } from 'vuex';
export const riskinfoMixin = {
  props: {
    disabledAll: {
      //页面输入框状态
      type: Boolean,
      default: false
    }
  },
  //监听属性 类似于data概念
  computed: {
		...mapState({
      agreementRead: (state) => state.insureDoc.agreementRead,//是否阅读告知书
      fileCodeContent: (state) => state.occupationCode.fileCodeContent,//协议文件是否全部已读
    }),
  },
  //生命周期 - 创建完成（可以访问当前this实例）期 - 销毁之前
  created() {
    const { u, p, planCode } = this.$route.query; //获取公共信息
    this.creator = u;
    this.productCode = p;
    this.plan = planCode;
  },
  methods: {
    goplicy() {
      // 去投保
      this.$store.commit('setAgreement', true);
    }
  },
  beforeDestroy() {
    this.$bus.$off('busRiskInfos');
  } //生命周期 - 销毁之前
};
